import { CardProps } from './types';
import {
  BlogCard,
  ContentCard,
  CTACard,
  ExcerptCard,
  LocationCard,
  NewsCard,
  PartnershipCard,
  SearchCard,
  StepCard,
  TeamCard,
} from './variants';
import LogoCardImage from './variants/LogoCardImage';
import MarketDataCard from './variants/MarketDataCard';

export const cardVariantMap: Record<CardProps['variant'], React.FC<any>> = {
  content: ContentCard,
  blog: BlogCard,
  location: LocationCard,
  cta: CTACard,
  partnership: PartnershipCard,
  news: NewsCard,
  team: TeamCard,
  excerpt: ExcerptCard,
  logoCardImage: LogoCardImage,
  search: SearchCard,
  marketData: MarketDataCard,
  step: StepCard,
};
